export default "__VITE_ASSET__CsX4475l__"